import AttributeLabelsModule, { AttributeLabel } from '@/store/AttributeLabelsModule'
import { clone } from '@/store/utils'
import { VueConstructor } from 'vue'
import { Vue } from 'vue/types/vue'

type ConstructorOf<C> = { new(...args: any[]): C }

export type StoreState = {
  [key: string]: any;
}

export class Store {
  stateInternal: StoreState = {}

  get state() {
    return clone(this.stateInternal)
  }

  getModule<M extends StoreModule>(module: ConstructorOf<M>): M {
    return clone(this.stateInternal[module.name]) as M
  }

  initLabels(labels: AttributeLabel[]) {
    const labelsRecord = labels.reduce((result, current) => {
      result[current.key] = current.value
      return result
    }, {} as Record<string, string>)

    this.updateModule(AttributeLabelsModule, { labels: labelsRecord })
  }

  protected registerModule<M extends StoreModule>(module: ConstructorOf<M>) {
    this.stateInternal[module.name] = new module()
  }

  private updateModule<M extends StoreModule>(module: ConstructorOf<M>, value: Partial<M>) {
    this.stateInternal[module.name] = { ...this.stateInternal[module.name], ...value }
  }
}

export const StorePlugin = (modules: ConstructorOf<StoreModule>[]) => {
  return {
    install(Vue: VueConstructor) {
      Vue.prototype.$store = new Store()
      modules.forEach(module => Vue.prototype.$store.registerModule(module))
    }
  }
}

export abstract class StoreModule {
}

declare module 'vue/types/vue' {
  interface Vue {
    $store: Store;
  }
}
